<template>
  <div id="app" data>
    <app-content>
      <router-view />
    </app-content>
  </div>
</template>
<script>
import AppContent from './AppContent.vue'

export default {
  components: {
    AppContent
  }
}
</script>
<style>

</style>




